import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var chip = createRuntimeFn({defaultClassName:'fx_b6b0f3e6_1vsx1ym3',variantClassNames:{size:{'default':'fx_b6b0f3e6_1vsx1ym4',large:'fx_b6b0f3e6_1vsx1ym5'},state:{'default':'fx_b6b0f3e6_1vsx1ym6',error:'fx_b6b0f3e6_1vsx1ym7'}},defaultVariants:{size:'default',state:'default'},compoundVariants:[]});

export { chip };
//# sourceMappingURL=chip.vanilla.mjs.map
